import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Flex } from './Flex'
import { Icon, IconName } from './Icon'
import { Color } from '../constants'
import { Intent, getIntentProps } from '../constants/intent'
import { theme } from '../constants/theme'
import { StyleProps, createStyles } from '../utils'

const CalloutComponent = styled.div<{
  backgroundColor: Color
  color: Color
  size?: CalloutSize
  styles?: StyleProps
}>((props) => {
  return {
    alignItems: 'flex-start',
    backgroundColor: props.backgroundColor,
    borderRadius: theme.border.radius.normal,
    color: props.color,
    display: 'flex',
    fontSize: props.size === 'sm' ? theme.font.size[6] : undefined,
    lineHeight: theme.lineHeight.relaxed,
    padding: theme.spacing[3],
    ...createStyles(props.styles),
  }
})

const Content = styled.div<{ size?: CalloutSize }>((props) => ({
  // Manual alignment with icon:
  marginTop: props.size === 'sm' ? 1 : 0,
  width: '100%',
}))

export type CalloutProps = {
  children: ReactNode
  className?: string
  icon?: IconName | null
  intent: Intent
  size?: CalloutSize
  styles?: StyleProps
}

export type CalloutSize = 'sm' | 'md'

export const Callout = (props: CalloutProps) => {
  const { backgroundColor, color, iconName } = getIntentProps(props.intent)

  return (
    <CalloutComponent
      backgroundColor={backgroundColor}
      className={props.className}
      color={color}
      size={props.size}
      styles={props.styles}
    >
      <Flex gap={2.5} styles={{ width: '100%' }}>
        {props.icon !== null && (
          <Icon color={color} name={props.icon ?? iconName} />
        )}
        <Content size={props.size}>{props.children}</Content>
      </Flex>
    </CalloutComponent>
  )
}
